import React from 'react';

import { CampaignsContextProvider } from '../V2/CampaignsContext';
import CampaignsV2ConfirmationModal from '../V2/CampaignsV2ConfirmationModal';

function CampaignSaveModal(props) {
  return (
    <CampaignsContextProvider>
      <CampaignsV2ConfirmationModal {...props} />
    </CampaignsContextProvider>
  );
}

export default CampaignSaveModal;
